import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import CloseIcon from '../../../assets/cross-icon-new.svg';

import '../../styles/views/components/Toast.scss';

const Toast = () => (
  <ToastContainer
    position="bottom-right"
    autoClose={5000}
    hideProgressBar
    newestOnTop
    closeOnClick
    pauseOnHover={false}
    rtl={false}
    pauseOnVisibilityChange
    draggable
    icon={false}
    closeButton={({ closeToast }) => (
      <button className="Toastify__close-button" onClick={closeToast}>
        <CloseIcon />
      </button>
    )}
  />
);

export default Toast;
